import React, {Component} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {MAX_CATEGORY_NAME_LENGTH} from '../../../constants';

import ValidationIcons from '../../../reusable/ValidationIcons/ValidationIcons';

class CategoryName extends Component {

    constructor(props) {
        super(props);

        this.changeCategoryNameInput = this.changeCategoryNameInput.bind(this);
        this.validateCategoryNameInputField = this.validateCategoryNameInputField.bind(this);
    }

    changeCategoryNameInput(event) {
        this.props.resetCategoryNameValidation();
        let inputValue = event.target.value;
        this.props.saveData({'name': inputValue});
    }

    validateCategoryNameInputField() {
        this.props.validateCategoryNameSection(this.props.data.name);
    }

    render() {

        return (
            <div className="category-name">

                <div className='category-name__title-characters'>
                    <div className='category-name__title-characters--remaining'>
                        <span>
                            {
                                MAX_CATEGORY_NAME_LENGTH - this.props.data.name.length >= 0 ?
                                    MAX_CATEGORY_NAME_LENGTH - this.props.data.name.length : 0
                            }
                        </span> <FormattedMessage
                        id="Alerts_Create_UIText_name.step1.charactersRemaining"/>
                    </div>
                </div>

                <div className="input-container">
                    <input type="text"
                           maxLength={MAX_CATEGORY_NAME_LENGTH}
                           className="category-name-input"
                           onBlur={this.validateCategoryNameInputField}
                           onChange={this.changeCategoryNameInput}
                           value={this.props.data.name}
                           placeholder={this.props.intl.formatMessage(
                               {id: 'Category_Create_UIText_addCategory.categoryName.placeholder'})}/>

                    <div className='validation-icons'>
                        {
                            this.props.categoryNameValidationIconsState ?
                                <ValidationIcons renderState={this.props.categoryNameValidationIconsState}/>
                                :
                                null
                        }
                    </div>

                </div>

                {
                    this.props.errorMessage ?
                        <div className="error-message"><FormattedMessage id={this.props.errorMessage}/></div>
                        :
                        null
                }

            </div>
        )
    }

}

export default injectIntl(CategoryName);


// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditCategories.CategoryName.jsx